import { useEffect, useState } from 'react';
import type { Loaded } from '../adapters/port.ts';

export type ViewState<T> =
  | { readonly kind: 'loading' }
  | { readonly kind: 'ok'; readonly value: T }
  | { readonly kind: 'empty' }
  | { readonly kind: 'error'; readonly message: string };

/** Carga con los tres estados no-felices explícitos. Ninguna vista puede ignorarlos. */
export function useLoaded<T>(load: () => Promise<Loaded<T>>): ViewState<T> {
  const [state, setState] = useState<ViewState<T>>({ kind: 'loading' });
  useEffect(() => {
    let alive = true;
    setState({ kind: 'loading' });
    load()
      .then((r) => { if (alive) setState(r); })
      .catch((e: unknown) => {
        if (alive) setState({ kind: 'error', message: e instanceof Error ? e.message : 'error desconocido' });
      });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return state;
}
